import React from 'react';
import Script from 'next/script';
export const FacebookConnectScript = () => <Script strategy="lazyOnload" crossOrigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js" data-sentry-element="Script" data-sentry-component="FacebookConnectScript" data-sentry-source-file="index.tsx" />;